import React from 'react';
import {connect} from 'react-redux';
import DocumentTitle from 'react-document-title';
import isNil from 'lodash/isNil';
import {Helmet} from 'react-helmet';

import {locationToString} from '../LocationName';
import {formatDate} from '~/misc/dates';

const directon = (origin, destination) =>
  `${locationToString(origin)} to ${locationToString(destination)} - Truckloads`;

const matched = (showCount) => {
  if (isNil(showCount)) {
    return '';
  }

  return `Loads: ${showCount},`;
};

const markUnviewed = (unviewed) => unviewed ? `(+${unviewed} new) ` : '';


const simpletTitle = (props) => {
  const origin = {
    city: props.from_city,
    state: props.from_state,
    name: props.from_name,
  };

  const destination = {
    city: props.to_city,
    state: props.to_state,
    name: props.to_name,
  };

  if (!props.loaded) {
    return `${directon(origin, destination)}`;
  }

  const {addedUnlooked, showCount} = props;

  return `${markUnviewed(addedUnlooked)}${matched(showCount)} ${directon(origin, destination)}`;
};

const word = (count) => {
  if (count === 1) {
    return 'load';
  }

  return 'loads';
};

const description = (props) => {
  const origin = {
    city: props.from_city,
    state: props.from_state,
    name: props.from_name,
  };

  const destination = {
    city: props.to_city,
    state: props.to_state,
    name: props.to_name,
  };

  const {addedUnlooked, showCount} = props;

  const count = showCount + (addedUnlooked || 0);

  if (!props.loaded) {
    return `${directon(origin, destination)}`;
  }

  return `At ${formatDate(new Date(props.searchSince))}, found ${count} ${word(count)}`
    + ` from ${directon(origin, destination)}`;
};


const Title = (props) => (<div>
  <Helmet>
    <meta
      name='description'
      content={description(props)}
    />
  </Helmet>
  <DocumentTitle title='Truckloads Carriers' />
  {/* <DocumentTitle title={simpletTitle(props)}/> */}
</div>);

export default connect(({loadsSearch: {
  addedUnlooked, allWithoutUnlooked, status, query = {}, search_since: searchSince,
}}) => ({
  loaded: status === 'ok' || status === 'refreshing',

  showCount: allWithoutUnlooked,
  addedUnlooked,

  from_city: query.from_city,
  from_state: query.from_state,
  from_name: query.from_name,

  to_city: query.to_city,
  to_state: query.to_state,
  to_name: query.to_name,
  searchSince: searchSince,
}))(Title);



// WEBPACK FOOTER //
// ./src/components/search/Title/index.js